import analytics from "fond/analytics";
import { EnrichedMultiProject, Project } from "fond/types";
import { PageMenuSection } from "fond/types/analytics";

export const trackPageMenuItemClick = (section: PageMenuSection, item: string, project?: Project | EnrichedMultiProject): void => {
  const projectType = project?.EntityType === "multi_project" ? "multi_project" : project?.Type;
  const projectSubType = project && "Subtype" in project && project.Subtype ? project.Subtype : undefined;
  analytics.track(`page-menu.${section}.item.clicked`, {
    item,
    projectType,
    projectSubType,
  });
};
